import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { MasterData } from '@/@types/masterData';

const VuexModule = createModule({
  namespaced: 'theoryApiMastersStore',
  strict: false,
});

export class MastersStore extends VuexModule {
  private readonly mastersRepository = RepositoryFactory.theoryApi.mastersRepository();
  /** state */
  /**
   * マスタデータ本体
   * @param {object} masterData
   */
  private masterData: MasterData | null = null;
  /**
   * マスタデータ存在フラグ
   * ページ遷移時やリロード時にマスタデータの存在をチェックする用途のフラグ
   * @param {boolean} isMasterData
   */
  private existFlag: boolean = false;

  @mutation
  private setMasterData(payload: MasterData) {
    this.masterData = payload;
    this.existFlag = true;
  }

  @mutation
  private setExistFlag(payload: boolean) {
    this.existFlag = payload;
  }

  @action
  async fetchMasterData() {
    const results = await this.mastersRepository.getMasterDataUrl();
    const signedUrl = results.results.signedUrl;
    const masterData = await this.mastersRepository.getMasterData(signedUrl);
    if (!masterData) {
      // TODO: マスタが正常取得出来ない場合の処理を考える
      throw new Error('masterData miss');
    }
    this.setMasterData(masterData);
  }

  get getExistFlag() {
    if (!this.masterData) {
      this.setExistFlag(false);
    }
    return this.existFlag;
  }

  get getAttributeStyle() {
    return this.masterData?.attributeStyle;
  }

  get getAttributeDisplayStyle() {
    return this.masterData?.attributeDisplayStyle;
  }

  get getGender() {
    return this.masterData?.gender;
  }

  get getSkill() {
    return this.masterData?.skill;
  }

  get getQualification() {
    return this.masterData?.qualification;
  }

  get getOccupation() {
    return this.masterData?.occupation;
  }

  get getSector() {
    return this.masterData?.sector;
  }

  get getProjectMemberRelationShip() {
    return this.masterData?.projectMemberRelationShip;
  }

  get getProcess() {
    return this.masterData?.process;
  }

  get getDevelopmentEnvironment() {
    return this.masterData?.developmentEnvironment;
  }

  get getPeriodUnit() {
    return this.masterData?.periodUnit;
  }

  get getPaymentUnitDivision() {
    return this.masterData?.paymentUnitDivision;
  }

  get getRole() {
    return this.masterData?.role;
  }

  get getColor() {
    return this.masterData?.color;
  }

  get getNotificationKind() {
    return this.masterData?.notificationKind;
  }

  get getActivityKind() {
    return this.masterData?.activityKind;
  }

  get getPrefecture() {
    return this.masterData?.prefecture;
  }

  get getCity() {
    return this.masterData?.city;
  }
}
